import React, { useRef } from 'react';

import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import StaticIcon from '../StaticIcon/StaticIcon';
import { Container as TotalPriceSummary } from '../TotalPriceSummary';

const FooterWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;

  > span {
    margin: auto 0;
    ${({ theme }) => theme.subHeader.variants.subHeading3Uppercase.textStyles};
  }
`;

const CheckoutButtonWrapper = styled.div`
  width: 100%;
`;

const ErrorMessage = styled.p`
  ${({ theme }) => theme.paragraph.variants.paragraph4.textStyles};
  text-transform: none;
  color: ${({ theme }) => theme.colors.error};
  padding-left: 6px;
  line-height: 14px;
`;

const OutOfStockWrapper = styled.div`
  display: flex;
  margin-top: 4px;
`;

const ErrorIcon = styled(StaticIcon)`
  fill: ${({ theme }) => theme.colors.red500};
`;

export function CartDrawerCollapsableFooter({
  checkoutButton,
  hasMembershipItem,
  showOutOfStockLabel,
}) {
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <FooterWrapper ref={ref}>
      <TotalPriceSummary
        onlyReturnTotalPrice
        isFromCart
        shouldShowAfterpay
        parentWrapperRef={ref}
        showFinalTotal={false}
        hasMembershipItem={hasMembershipItem}
      />
      <CheckoutButtonWrapper>
        {checkoutButton}
        {showOutOfStockLabel && (
          <OutOfStockWrapper>
            <ErrorIcon type="error" size={14} />
            <ErrorMessage>
              <FormattedMessage
                id="global_checkout.remove_sold_out_products"
                defaultMessage="Remove Sold Out products to continue"
              />
            </ErrorMessage>
          </OutOfStockWrapper>
        )}
      </CheckoutButtonWrapper>
    </FooterWrapper>
  );
}
